<template>
  <v-row>
    <v-col
      cols="12"
      class="mb-2"
    >
      <v-tabs>
        <v-tab exact :to="{ name: 'system-admin-affiliates-list' }">Affiliates</v-tab>
        <v-tab exact :to="{ name: 'system-admin-affiliates-statistic' }">Statistics</v-tab>
      </v-tabs>

      <v-card class="white">
        <v-card-text>
          <v-tabs-items v-model="currentTab">
            <v-tab-item
              :value="currentTab"
              transition="none"
              reverse-transition="none"
            >
              <v-row>
                <v-col
                  cols="12"
                  class="mb-2"
                >
                  <v-text-field
                    v-model="searchVal"
                    label="Search"
                    hide-details
                    outlined
                    clearable
                    append-icon="mdi-magnify"
                    @click:append="getDataFromApi()"
                    @keydown="checkKeypress"
                  />
                </v-col>
                <v-col cols="12" style="position: relative;">
                  <v-card>
                    <v-btn
                      absolute
                      dark
                      fab
                      top
                      right
                      small
                      color="primary"
                      :to="{name: 'system-admin-affiliates-create'}"
                      v-if="$store.getters.userIs('systemAdmin')"
                    >
                      <v-icon small>mdi-plus</v-icon>
                    </v-btn>
                    <v-data-table
                      :headers="headers"
                      :items="affiliates"
                      :options.sync="options"
                      :server-items-length="totalAffiliates"
                      :loading="loading"
                      :footer-props="tableFooterProps"
                      @update:options="getAffiliates"
                    >
                      <template v-slot:[`item.name`]="{ item }">
                        <div class="py-2">{{ item.name }}</div>
                      </template>
                      <template v-slot:[`item.status`]="{ item }">
                        <div class="text-center">
                          <span>
                            <v-tooltip top>
                              <template v-slot:activator="{on}">
                                <v-icon v-on="on"
                                  :class="{ 'error--text': item.status === 0, 'primary--text': item.status === 1 }"
                                >
                                  mdi-circle
                                </v-icon>
                              </template>
                              <span>{{ item.status === 0 ? 'Inactive' : 'Active'}}</span>
                            </v-tooltip>
                          </span>
                        </div>
                      </template>
                      <template v-slot:[`item.referral_link`]="{ item }">
                        <v-text-field
                          readonly
                          :value="item.referral_link"
                          outlined
                          dense
                          hide-details
                          @click.stop="copyInviteLink(item, $event)"
                        />
                      </template>
                      <template v-slot:[`item.promo_link`]="{ item }">
                        <v-text-field
                          readonly
                          :value="item.promo_link"
                          outlined
                          dense
                          hide-details
                          @click.stop="copyInviteLink(item, $event)"
                        />
                      </template>
                      <template v-slot:[`item.created_at`]="{ item }">
                        {{ $moment.unix(item.created_at).calendar() }}
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-btn class="mr-2" elevation="2" text x-small @click="view(item.id)">View</v-btn>
                        <v-btn elevation="2" text x-small @click="edit(item.id)">Edit</v-btn>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { TABLE_FOOTER_PROPS } from '@/global/consts';

export default {
  name: 'AdminAffiliatesList',
  data: () => ({
    currentTab: 'list',
    loading: true,
    searchVal: null,
    headers: [
      {
        text: 'ID',
        align: 'start',
        value: 'id',
        width: '80px'
      },
      {
        text: 'Name',
        align: 'start',
        value: 'name',
      },
      {
        text: 'Type',
        align: 'start',
        value: 'type',
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
      },
      {
        text: 'Affiliate Link',
        align: 'start',
        sortable: false,
        value: 'referral_link'
      },
      {
        text: 'Promo Link',
        align: 'start',
        sortable: false,
        value: 'promo_link'
      },
      {
        text: 'Created',
        align: 'start',
        value: 'created_at',
      },
      {
        text: 'Actions',
        align: 'start',
        width: '150px',
        value: 'actions',
      },
    ],
    affiliates: [],
    totalAffiliates: 0,
    options: {
      sortBy: ['created_at'],
      sortDesc: [true]
    },
    tableFooterProps: { ...TABLE_FOOTER_PROPS },
  }),
  methods: {
    getAffiliates() {
      this.loading = true;

      const queryParams = this.getAffiliateQueryParams();
      this.$http.get('affiliates?' + queryParams)
        .then(response => {
          this.affiliates = response.data.items
          this.totalAffiliates = response.data._meta.totalCount
        })
        .catch(err => {
          if(err.response.status == 401) return;
          this.$swal.fire('Error', 'There was an error loading affiliates', 'error')
        })
        .finally(() => this.loading = false)
    },
    getAffiliateQueryParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const qParams = [];

      if (sortBy[0]) {
        qParams.push('sort=' + (sortDesc[0] ? '-' : '') + sortBy[0]);
      }
      qParams.push('per-page=' + itemsPerPage)
      qParams.push('page=' + page)
      if (this.searchVal) {
        qParams.push('s=' + encodeURIComponent(this.searchVal))
      }
      return qParams.join('&');
    },
    edit(affiliate_id) {
      if (this.$store.getters.userIs('systemAdmin')) {
        this.$router.push({ name: 'system-admin-affiliates-edit', params: { affiliate_id } })
      }
    },
    view(affiliate_id) {
      if (this.$store.getters.userIs('systemAdmin')) {
        this.$router.push({ name: 'system-admin-affiliates-commissions', params: { affiliate_id } })
      }
    },
    checkKeypress(e) {
      if(e.key == 'Enter') this.getAffiliates()
    },
    copyInviteLink(item, e) {
      e.target.select()
    }
  }
}
</script>